import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import CustomersPowerSelect from '../../customers/customers-power-select.jsx';

export default class SystemSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      isLoading: !props.systemSettings,
      momentFormatString: 'ddd Do MMM YYYY',
      momentFormatStringCSV: 'ddd Do MMM YYYY - HHmmss',
      systemSettings: props.systemSettings || null,
      url: props.url ||
        '/api/v1/portal/portal-admin/system-settings',
      saveUrl: props.saveUrl ||
        '/api/v1/portal/portal-admin/system-settings/company-customers',
      acvCustomerId: null,
      bvlCustomerId: null,
      cndCustomerId: null,
      g4CustomerId: null,
      sccdCustomerId: null,
      acvtruckCustomerId: null,
    };
  }

  getSystemSettingsForCompany() {
    return fetch(this.state.url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        this.setState({
          systemSettings: response,
          isLoading: false
        })
      });
    });
  }

  handleCustomerSelection(e, companyTLA) {
    switch(companyTLA) {
      case 'ACV':
        this.setState({
          acvCustomerId: e.id
        });
        break;
      case 'BVL':
        this.setState({
          bvlCustomerId: e.id
        });
        break;
      case 'CND':
        this.setState({
          cndCustomerId: e.id
        });
        break;
      case 'G4':
        this.setState({
          g4CustomerId: e.id
        });
        break;
      case 'SCCD':
        this.setState({
          sccdCustomerId: e.id
        });
        break;
      case 'ACV-TRUCK':
        this.setState({
          acvtruckCustomerId: e.id
        });
        break;
    }
  }

  saveCustomer(e, companyTLA) {
   let companyCustomerData = {};

    switch(companyTLA) {
      case 'ACV':
        companyCustomerData.acvCustomerId = this.state.acvCustomerId;
        break;
      case 'BVL':
        companyCustomerData.bvlCustomerId = this.state.bvlCustomerId;
        break;
      case 'CND':
        companyCustomerData.cndCustomerId = this.state.cndCustomerId;
        break;
      case 'G4':
        companyCustomerData.g4CustomerId = this.state.g4CustomerId;
        break;
      case 'SCCD':
        companyCustomerData.sccdCustomerId = this.state.sccdCustomerId;
        break;
      case 'ACV-TRUCK':
        companyCustomerData.acvtruckCustomerId = this.state.acvtruckCustomerId;
        break;
    }

    return fetch(this.state.saveUrl, {
      method: "POST",
      mode: "cors",
      cache: "no-cache",
      credentials: "same-origin",
      headers: {
        "Authorization": 'Bearer ' + window.api_token
        , "Accept": 'application/json'
      },
      body: JSON.stringify(companyCustomerData)
    }).then((responseText) => {
      let response = responseText.json();
      response.then((response) => {
        console.log(response);
      });
    });
  }

  componentDidMount() {
    if (this.state.isLoading) {
      this.getSystemSettingsForCompany();
    }
    let that = this;
    Echo.channel('system-settings')
      .listen('SystemSettingsChanged',
        (e) => {
        that.getSystemSettingsForCompany();
      });
  }


  componentWillReceiveProps(nextProps) {
    this.setState({
      customers: nextProps.customers
    });
  }

  render() {
    return (
          (this.state.isLoading) ?
            (<span className="add-loading-text">
          <i className="fa fa-spinner fa-pulse"></i></span>) :
          <div>
            <div className="row">
              <div className="col-md-12 col-sm-12">
                <h2>System Settings</h2>
              </div>
            </div>

            <div className="row">
              <div className="col-md-4">
              </div>
              <div className="col-md-4 col-sm-12">
                <h3>
                  Company Customers (for Subcontracting Invoicing)
                </h3>

                <div className="system-setting-item-container">
                  <label>ACV</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.acv_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e,'ACV')
                    }
                  />
                    <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e,'ACV')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>

                <div>
                  <label>BVL</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.bvl_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e, 'BVL')
                    }
                  />
                  <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e, 'BVL')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>

                <div>
                  <label>CND</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.cnd_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e, 'CND')
                    }
                  />
                  <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e, 'CND')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>

                <div>
                  <label>G4</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.g4_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e, 'G4')
                    }
                  />
                  <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e, 'G4')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>

                <div>
                  <label>SCCD</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.sccd_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e,'SCCD')
                    }
                  />
                  <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e,'SCCD')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>
                <div>
                  <label>ACV-TRUCK</label>
                  <CustomersPowerSelect
                    selectedOption={this.state.systemSettings.acv_truck_customer_id}
                    handleCustomerSelection={
                      (e) => this.handleCustomerSelection(e,'ACV-TRUCK')
                    }
                  />
                  <p
                      className="text-right"
                    >
                      <button
                        className="btn btn-sm btn-success"
                        onClick={(e) => this.saveCustomer(e,'ACV-TRUCK')}
                      >
                        <i className="fa fa-save"></i> save
                      </button>
                    </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
            </div>
        </div>
    );
  }
}
if (document.getElementById(
  'react-component-g4-logistics-portal-portal-admin-system-settings')) {
  ReactDOM.render(
    <SystemSettings
      message_if_none = 'No Customers found. Add one to see it here.'
    />,
    document.getElementById(
      'react-component-g4-logistics-portal-portal-admin-system-settings'
    )
  );
}